var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaggedResponse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.501,
    height: 21.775,
    viewBox: "0 0 18.501 21.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9879",
    "data-name": "Group 9879",
    transform: "translate(-13432.625 -5733.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "analysis",
    d: "M31.783,4.18A1.666,1.666,0,0,0,30.5,3.655H17.786a1.716,1.716,0,0,0-1.715,1.714V19.5a1.14,1.14,0,0,0,1.139,1.138H28.122A1.14,1.14,0,0,0,29.26,19.5V11.161h2.1a.859.859,0,0,0,.858-.858V5.392A1.8,1.8,0,0,0,31.783,4.18ZM28.79,16.619V19.5a.668.668,0,0,1-.668.667H17.21a.668.668,0,0,1-.668-.667V5.369a1.245,1.245,0,0,1,1.243-1.243H29.325a1.71,1.71,0,0,0-.535,1.243v8.88S28.79,16.371,28.79,16.619ZM31.745,10.3a.387.387,0,0,1-.387.387h-2.1V5.369A1.245,1.245,0,0,1,30.5,4.126a1.179,1.179,0,0,1,1.242,1.266ZM18.769,7.724A.236.236,0,0,1,19,7.488h7.4a.236.236,0,0,1,0,.471H19a.236.236,0,0,1-.236-.236Zm0,2.52A.236.236,0,0,1,19,10.008h7.4a.236.236,0,0,1,0,.471H19a.236.236,0,0,1-.236-.236Zm0,2.52A.236.236,0,0,1,19,12.528h7.4a.236.236,0,0,1,0,.471H19a.236.236,0,0,1-.236-.236Z",
    transform: "translate(13416.929 5730.345)",
    fill: "#2863ff",
    stroke: "#2863ff",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9878",
    "data-name": "Group 9878",
    transform: "translate(13439.527 5743.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7687",
    "data-name": "Path 7687",
    d: "M0-1H11.418V10.418H0Z",
    transform: "translate(0 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "time-past",
    transform: "translate(0.879 0.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7676",
    "data-name": "Path 7676",
    d: "M23.157,30.328A5.305,5.305,0,1,0,25.146,23.1a5.239,5.239,0,0,0-.851.6l-.013-.553a.482.482,0,1,0-.965.023l.033,1.416a.782.782,0,0,0,.786.769.522.522,0,0,0,.056,0l1.412-.1a.482.482,0,1,0-.065-.961l-.49.033a4.263,4.263,0,0,1,.575-.392,4.345,4.345,0,0,1,5.917,1.626,4.272,4.272,0,0,1,.421,1.03,4.354,4.354,0,0,1-.769,3.782,4.263,4.263,0,0,1-1.278,1.1A4.344,4.344,0,0,1,24,29.852a4.273,4.273,0,0,1-.534-1.6.482.482,0,1,0-.957.115,5.247,5.247,0,0,0,.651,1.964Z",
    transform: "translate(-22.502 -22.402)",
    fill: "#2863ff",
    stroke: "#2863ff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7677",
    "data-name": "Path 7677",
    d: "M43.552,36.81a.481.481,0,0,0-.482.482v2.4a.472.472,0,0,0,.142.34l1.7,1.7a.482.482,0,0,0,.68-.684l-1.559-1.559v-2.2A.484.484,0,0,0,43.552,36.81Z",
    transform: "translate(-39.117 -34.041)",
    fill: "#2863ff",
    stroke: "#2863ff",
    strokeWidth: 0.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaggedResponse);
export default __webpack_public_path__ + "static/media/taggedResponse.99917bea50a66404e8ffe122664953aa.svg";
export { ForwardRef as ReactComponent };